export enum CreateAccountReferrer {
    GeneralCreateAccount = 1,
    CartCreateAccount = 3,
}